module.exports = __webpack_public_path__ + "img/coding-animate.081dad70.svg";